module Masks {
  export function construct() {
    const jquery = ($ as any);
    jquery.jMaskGlobals = {
      maskElements: 'input,td,span,div',
      dataMaskAttr: '*[data-mask]',
      dataMask: true,
      watchInterval: 100,
      watchInputs: true,
      watchDataMask: false,
      byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
      translation: {
        '0': { pattern: /\d/ },
        '1': { pattern: /[2-9]/ },
        '9': { pattern: /\d/, optional: true },
        '#': { pattern: /\d/, recursive: true },
        'A': { pattern: /[a-zA-Z0-9]/ },
        'S': { pattern: /[a-zA-Z]/ }
      }
    };
    jquery.applyDataMask();
  }
}